/**
 * @generated SignedSource<<7c959231c5afb90feea19916448bd44b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type thingsToDoQuery$data = {
  readonly thingsToDoQueue: {
    readonly items: {
      readonly __typename: "QueueItemConnection";
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"postiesPrimaryContentItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly thingsToDoSection: {
    readonly " $fragmentSpreads": FragmentRefs<"headlineSection">;
  };
  readonly " $fragmentType": "thingsToDoQuery";
};
export type thingsToDoQuery$key = {
  readonly " $data"?: thingsToDoQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"thingsToDoQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "thingsToDoQuery",
  "selections": [
    {
      "alias": "thingsToDoSection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "515465"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "headlineSection"
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"515465\"})"
    },
    {
      "alias": "thingsToDoQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "section_top_515465"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "postiesPrimaryContentItemContent"
                        }
                      ],
                      "type": "Article",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:1)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"section_top_515465\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bfbf2cbc54ceafa0c0352e7823053d3a";

export default node;
